import React from "react";
import { Navigate } from "react-router-dom";

/** Teknikler, Atölye ve Teknikler ekranının "Teknikler" sekmesinde yönetilir; eski adres oraya yönlenir. */
const Technics: React.FC = () => <Navigate to="/workshops?tab=technics" replace />;

export default Technics;
